import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import dateFormat from 'dateformat';
import { Cnt, StyledTable } from './table-styles';
import { getDateTimeFormat } from '#helper';

export default props => {
  const measurementSystem = useSelector(s => s.account.measurementSystem);
  const format = useMemo(() => getDateTimeFormat(measurementSystem, 'dateTimeShort'), [measurementSystem]);
  const { projectsToChange } = props;

  return (
    <Cnt>
      The new date range will be set to sub-projects
      <br />
      <StyledTable aria-label="projects will be changed">
        <TableHead>
          <TableRow>
            <TableCell>Project name</TableCell>
            <TableCell>Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {projectsToChange.map(p => (
            <TableRow key={p.id}>
              <TableCell component="th" scope="row">
                {p.title}
              </TableCell>
              <TableCell>
                {`${dateFormat(new Date(p.beginDate), format)}${
                  p.expirationDate ?
                    ` – ${dateFormat(new Date(p.expirationDate), format)}` :
                    ''}`}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </StyledTable>
    </Cnt>
  );
};
